/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import Plot from "react-plotly.js";
import React from "react";

export const ScatterPlot = (props) => {
  const {xyzData, isError, is3d} = props
  let _xyzData = null
  if (!is3d && xyzData?.x && xyzData?.y && xyzData?.z) {
    console.error("set not 3d, but have x,y,z")
    _xyzData = {x: [...xyzData?.x], y: [...xyzData?.y]}
  }

  const data = _xyzData ?? xyzData
  const scatter3dData = [
    {
      mode: 'markers',
      ...data,
      hoverinfo: 'point',
      type: is3d ? 'scatter3d' : 'scatter2d',
      name: 'Origin',
      showlegend: true,
      marker: {
        color: 'rgb(17, 157, 255)',
        size: 2,
      },
    },
  ];
  const data1 = scatter3dData?.[0]
  const isDataSet = data1?.x && data1?.y && (is3d ? data1?.z : true)
  const isValidData = !isError
  const errorMessage = !isDataSet ? "no graph data available" : "invalid data, not showing plot"
  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      {isDataSet && isValidData ? (
          <Plot
            data={scatter3dData}
            layout={{
              showlegend: false,
              gridcolor: "#f2f4f5",
              height: "100%",
              width: "100%",
              title: false,
              xaxis: {title: 'azimuth angle (degrees)', padding: 14, automargin: true},
              yaxis: {title: 'range (meters)', automargin: true},
            }}
          />
        ) :
        <div style={{marginTop: 20}}>
          {errorMessage}
        </div>
      }
    </div>
  )
}